import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "ui/components/sheet";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Form } from "react-crud-form";
import { FormLabel } from "components/form";
import { useForm } from "react-hook-form";
import React from "react";
import { Input } from "ui/components/input";
import { useParams } from "react-router-dom";
import { createDeliverable } from "./api";
import { Button } from "ui/components/button";
import { invalidateAllQueries } from "utils/utils";
import { eventBus } from "utils/eventBus";

export default function CreateDeliverableDialog({ open, onOpenChange }) {
  const form = useForm({
    defaultValues: {
      name: "",
      url: "",
    },
  });
  const { casestudyId } = useParams();

  async function handleCreate(context) {
    const values = context.values;
    const response = await createDeliverable({
      item: {
        ...values,
        case_study: casestudyId,
      },
    });
    invalidateAllQueries();
    eventBus.emit("refresh:list", `deliverablesdeliverables${casestudyId}`);
    onOpenChange(false);
    form.reset();
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="!p-4">
        <SheetHeader>
          <SheetTitle>Create</SheetTitle>
        </SheetHeader>
        <Form form={form} create={handleCreate} itemId="+">
          {({ isCreating, createItem, isDirty, isNewItem }) => (
            <div className="grid gap-4">
              {/* Name */}
              <FormField
                control={form.control}
                name="name"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Name</FormLabel>
                    <Input {...field} />
                    <FormMessage />
                  </FormItem>
                )}
              />

              {/* URL */}
              <FormField
                control={form.control}
                name="url"
                render={({ field }) => {
                  return (
                    <FormItem>
                      <FormLabel>URL</FormLabel>
                      <Input {...field} />
                      <FormMessage />
                    </FormItem>
                  );
                }}
              />

              <div className="flex justify-end">
                <Button
                  type="button"
                  onClick={createItem}
                  disabled={!isDirty || isCreating}
                  loading={isCreating}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
        </Form>
      </SheetContent>
    </Sheet>
  );
}
